import { CurrentQuestionSingle } from './CurrentQuestionSingle';
import { ConditionMethods, QuestionMethods } from '../questionMethods.types';
import {
	SingleSelectGivenAnswer,
	RenderedSingleSelectQuestion,
} from './singleSelectMethods.types';
import { SingleSelectCondition } from '@/globals/webApiTypes/elements/WebAPIDecisionToolData';
import { AnsweredQuestionSingle } from './AnsweredQuestionSingle';
import { isSingleSelectAnswered } from './isSingleSelectAnswered';
import { getSingleSelectAnswerListItems } from './getSingleSelectAnswerListItems';
import {
	addSingleSelectToGivenAnswers,
	addSingleSelectToSearchParams,
} from './addSingleSelectToSearchParams';

export const SingleSelectQuestionMethods: QuestionMethods<
	RenderedSingleSelectQuestion,
	SingleSelectGivenAnswer
> = {
	Current: CurrentQuestionSingle,
	Answered: AnsweredQuestionSingle,
	isAnswered: isSingleSelectAnswered,
	getAnswerListItems: getSingleSelectAnswerListItems,
	addToGivenAnswers: addSingleSelectToGivenAnswers,
	addToSearchParams: addSingleSelectToSearchParams,
};

export const SingleSelectConditionMethods: ConditionMethods<SingleSelectCondition> =
	{
		isMatch: ({ condition, givenAnswers }) => {
			const givenAnswer = givenAnswers.single.get(condition.questionId);
			if (givenAnswer == null) return true;

			return condition.answerIds.includes(givenAnswer);
		},
		isValid: (condition) => {
			return condition.answerIds.length > 0;
		},
	};
